var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-controls"},[(_vm.state.mode === 'riding')?_c('v-button',{attrs:{"type":"light","icon":"stop"},on:{"click":_vm.stopRoute}},[_vm._v(" Route beëindigen ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }